export const SHAPE_LIMIT_REACHED_REASON =
  "This plan has reached its shape limit.";

export const LOCKED_BY_OTHER_ADD_REASON =
  "You cannot add items while this floorplan is locked and being edited by another user.";

type AddShapeBlockedStore = {
  lockedByOther: boolean;
  editingByName?: string | null;
};

/**
 * Distinguishes why addSymbol/addWall returned empty: another collaborator
 * holds the edit lease, or the freemium shape cap was hit.
 */
export const getAddShapeBlockedReason = (
  store: AddShapeBlockedStore,
): string => {
  if (!store.lockedByOther) return SHAPE_LIMIT_REACHED_REASON;
  const name = store.editingByName?.trim();
  if (!name) return LOCKED_BY_OTHER_ADD_REASON;
  return `You cannot add items while this floorplan is locked and being edited by ${name}.`;
};
